import { Component, HostBinding, Input } from '@angular/core';
import { BcmSettingsFacade } from '@bcmServices/settings/bcm-settings-facade';
import { BcmService } from '@modules/bcm/bcm.service';

@Component({
    selector: 'bcm-product-price-label',
    template: `
        {{ text ? text : ('table.singlePrice' | translate) }}
        <ng-container *ngIf="lineBrake"><br></ng-container>
        <ng-container *ngIf="(settingsState.settings$ | async) as settings">
            <ng-container *ngIf="switchToNet; else defaultLabel">
                ({{settings.invoice_template?.showSinglePriceInNet || bcmService?.managePricesInNet ? ('common.net' | translate) : ('common.gross' | translate)}})
            </ng-container>
            <ng-template #defaultLabel>
                ({{bcmService?.managePricesInNet ? ('common.net' | translate) : ('common.gross' | translate)}})
            </ng-template>
        </ng-container>
    `,
    styles: [':host { white-space: normal }'],
    standalone: false
})
export class ProductPriceLabelComponent {

    @Input()
    text: string;

    @Input()
    switchToNet = false;

    @Input()
    @HostBinding('style.text-align')
    textAlign: 'left' | 'right' | 'center' = 'right';

    @Input()
    lineBrake = false;

    constructor(public settingsState: BcmSettingsFacade,
                public bcmService: BcmService) {
    }

}
